/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-05-07 11:38:34
 */
import request from '@api/request.js'

const BASE_URL = 'lishui-gov'

// 机器人列表
export const getRobotInfoByPage = params =>
  request.get(BASE_URL + '/robotManage/getRobotInfoByPage', { params })

//  新增机器人
export const addRobotInfo = params =>
  request.post(BASE_URL + '/robotManage/addRobotInfo', params)

// 编辑机器人
export const updateRobotInfo = params =>
  request.post(BASE_URL + '/robotManage/updateRobotInfo', params)

// 删除机器人
export const deleteRobotInfo = params =>
  request.post(BASE_URL + '/robotManage/deleteRobotInfo', params)
